._1q2j39p0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--pluma-space-150);
  padding: var(--pluma-space-400);
  border: var(--pluma-border-width-0125) dashed var(--pluma-color-border-base);
  border-radius: var(--pluma-radius-4);
  background-color: var(--pluma-color-surface-base);
  text-align: center;
}
._1q2j39p1 {
  border-color: var(--pluma-color-border-accent);
  background-color: var(--pluma-color-surface-accent);
}
._1q2j39p2 {
  opacity: 0.6;
  pointer-events: none;
}
._1q2j39p3 {
  display: none;
}